<template>
  <div class="Rank">
    <side_bar :links="links"></side_bar>
    <r_header v-if="!$store.state.mediaPhone"></r_header>
    <div v-if="user">
      <my_rank v-if="procedure == 1" :info="myRank"></my_rank>
      <prelim v-if="procedure == 2 || procedure == 3" :success="user.is_repecharge" :passed="passed"></prelim>

      <div v-if="procedure == 6 && user" class="info">
        <div>
          亲爱的参赛选手，
        </div><br><div>
          接中国下一代教育基金会通知，第二届（2021-2022学年）少年硅谷  全国青少年人工智能教育成果大赛奖项将由中国下一代教育基金会统一公布，成绩分选拔赛成绩和全国决赛成绩，请参赛选手近期登陆<a href="http://snggds.cngef.org.cn" target="_blank">基金会网站</a>查询比赛成绩。祝你好运！
        </div>
        <div class="badging">
          <div>
            AI算法竞技赛组委会
          </div>
          <div>
            2022年8月6日
          </div>
        </div>

      </div>

      <repe v-if="procedure == 4.5 && !success" :success="true" :passed="true"></repe>
      <!-- <final v-if="procedure == 6 && reward"></final> -->
      <!-- <result v-if="procedure > 3"></result> -->
    </div>
    <div class="group" v-if="procedure==1">
      <div class="grp fs20" :class="{focus: leaderboard=='personal' }"  @click="focus('personal')">全国排名</div>
      <div class="grp fs20" v-if="user" :class="{focus: leaderboard=='province'}"  @click="focus('province')">省级排名</div>
    </div>
    <!-- <div v-if="leaderboard == 'personal'"> -->
    <rank v-if="procedure <= 1" :procedure="procedure" :leaderboard="leaderboard"></rank>
    <reprank v-if="procedure == 5 && success" :procedure="procedure"></reprank>
    <div v-if="procedure == 3" class="info">
      复赛成绩请在复赛结束后登录查询
    </div>

    <div v-if="procedure == 4" class="info column">
      感谢你参加教育部白名单竞赛少年硅谷AI算法竞技赛，
      <br><br>比赛结果将于2022年7月4日公布，晋级国赛的选手将参加国赛，
      <br><br>
      <b>比赛时间2022年7月5日00:00:00开始，2022年7月30日16:00:00结束。</b>
      <br><br>
      未晋级国赛的参赛选手请及时关注少年硅谷AI算法竞技赛官方网站公告和扣哒世界官方微信公众号，及时了解省级奖项评选结果，
      <br><br>AI算法竞技赛组委会在得到中国下一代教育基金会官方确认全国级和省级奖项名单后，将第一时间对外公布，并通过短信通知获奖选手。
    </div>

    <!-- </div> -->
    <!-- <div v-else>
         <school_rank v-if="procedure == 1 || procedure == 2" :procedure="procedure"></school_rank>
         <school_reprank v-if="procedure == 3 || procedure == 4" :procedure="procedure"></school_reprank>
         </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment'

import SideBar from '@/components/SideBar.vue';
import RHeader from '@/components/frontpage/Header.vue';
import MyRank from '@/components/score/MyRank.vue';
import Rank from '@/components/score/Rank.vue';
import RepRank from '@/components/score/RepRank.vue';
import Prelim from '@/components/score/Prelim-22.vue';
import Repe from '@/components/score/Repe.vue';
import Final from '@/components/score/Final.vue';
import Result from '@/components/score/Result.vue';
import SchoolRank from '@/components/score/SchoolRank.vue';
import SchoolRepRank from '@/components/score/SchoolRepRank.vue';

import MyButton from '@/components/Button.vue'
import MyInput from '@/components/Input.vue';
export default {
  name: 'Rank',
  computed: {
    styleInput() {
      return {
        border: '1px solid #333',
        'margin-left': '-30px'
      }
    },
    links () {
      return this.$store.state.sbar.linksFP
    },

    success () {
      if(this.user)
        return this.$store.state.auth.game_state[this.game_year+'-2'].state == 1
      else
        return false
    },
    passed () {
      if(this.user)
        return this.$store.state.auth.game_state[this.game_year+'-1'].state > 1
      else
        return false
    },
    user() {
      return this.$store.state.auth.user
    },
    group() {
      return ['小学组', '初中组', '高中组']
    },
    procedure() {
      let time = moment(+new Date() + this.$store.state.timeDelay)
      console.log("?time?", time)
      let proce = this.$store.state.procedure
      if(proce == 4 && time.isAfter('2022-07-04 00:00:00')) {
        return 4.5
      }
      return proce
    },
    game_year() {
      return this.$store.state.game_slug.slice(0, 4)
    },
    game_slug() {
      return this.$store.state.game_slug
    },
    reward () {
      if(this.user)
        return this.$store.state.auth.game_state[this.game_year+'-3'].state >= 0
      else
        return false
    }
  },
  methods: {
    checkCertify() {
      if(this.fm.id && /^[1-9]\d{5}(18|19|20|21|22)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(this.fm.id))
        return true;
      return false
    },
    fetchCode() {
      this.$http.post('/api/user/fetch_new_code')
          .then(res => {
            this.code = res.data.code
          })
    },
    focus(f) {
      this.leaderboard = f;
    },
    copy() {

      navigator.clipboard.writeText(this.code).then(() => {
        this.$noty.success('复制成功!', {
          layout: 'center',
          timeout: 2000,
          progressBar: false,
          theme: 'relax',
        })
      })
    }
  },
  data () {
    return  {
      state: '确认修改',
      fm: {
        id: '',
      },
      error: {
        id: '',
      },
      myRank: {
        '姓名': '__',
        '组别': '__',
        '积分/全国排名': '__',
        '省级排名': '__',
      },
      code: '',
      score: null,
      /* passed: false, */
      leaderboard: 'personal',
    }
  },
  mounted() {
    let group = this.group;
    if(this.user){
      this.fm.id = this.user.idcard;
      this.$http.get('/api/code/fetch')
          .then(res => {
            this.code = res.data.code
          })
      if( this.user.enrolled&&this.procedure == 1)
      {
        this.$http.get(`/api/rank/user?user_id=${this.user.id}&round=${this.game_slug}`)
            .then(res=>{
              this.myRank = {
                '姓名': res.extra.username,
                '组别': group[this.user.group-1],
                '积分/全国排名': `${res.extra.ozaria}/${res.extra.rank}`,
                '省级排名': res.extra.area_rank,
                /* '区域': res.extra.area_name, */
                /* '积分/全国排名': `${res.extra.score}/${res.extra.rank}`, */
              }
              /* this.passed = (res.extra.ozaria > 0) */
            })
      }
      else{
        this.myRank={
          '姓名': this.user.name,
          '组别': '/',
          '积分/全国排名': '未报名',
          '省级排名': '未报名'
        }
      }
    }
  },

  components: {
    my_button: MyButton,
    my_input: MyInput,
    r_header: RHeader,
    my_rank: MyRank,
    prelim: Prelim,
    repe: Repe,
    final: Final,
    rank: Rank,
    reprank: RepRank,
    side_bar: SideBar,
    school_rank: SchoolRank,
    school_reprank: SchoolRepRank,
    result: Result
  }
}
</script>

<style scoped>
.wait {
  margin: 200px;
  text-align: center;
  font-size: xx-large;

}
.group{
  display: flex;
  align-items:center;
  justify-content: space-around;
  width: 100vw;
  border-bottom: 1px dashed black;
  margin-bottom: 1.5625vw;
  margin-top: 5vw ;
}
.grp{
  line-height: 2.5vw;
}
.focus{
  border-bottom: 1px solid black;
  color: #4411FF;
}
.info {

  font-size: 18px;
  text-indent: 2em;
  padding-left: 20%;
  padding-right: 20%;
    display: flex;
    flex-direction: column;
    align-items:flex-start;
  margin: 4em 6em;
  /* height: 10em; */
}

  .badging{
    margin-top: 1em;
    color: #585668;
    align-self: flex-end;
  }
.column{
  flex-direction: column;
}

.content{
  width: 60%;
  margin-left: 20%;
  text-indent: 2em;
}
</style>